/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.user.timezones.rpc.MomentTimezonesRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getByTimezoneRpc = {
  serviceName: 'com.hubspot.user.timezones.rpc.MomentTimezonesRpc',
  rpcName: 'getByTimezone',
  auth: 'app',
  fingerprint: 'jVwYHU5h8wE9axf7rPe9TZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};